import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { BadgeCheck, MapPin, Loader2, Palmtree } from "lucide-react";

export default function JamaicaMade() {
  const [merchants, setMerchants] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/merchants", { params: { jamaica_made: true } }), api.get("/products", { params: { category: "jamaica-made" } })])
      .then(([m, p]) => { setMerchants(m.data); setProducts(p.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div>
      <section className="relative overflow-hidden sn-noise" style={{ background: "linear-gradient(120deg,#8E0E13,#0A0A0C)" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-white relative">
          <span className="inline-flex items-center gap-2 sn-glass sn-pill px-4 py-1.5 text-xs font-semibold uppercase tracking-wider"><Palmtree size={14} className="text-gold" /> Jamaica Made</span>
          <h1 className="font-clash font-bold text-4xl sm:text-6xl mt-4">Proudly Made in Jamaica.</h1>
          <p className="text-white/70 mt-4 max-w-xl text-lg">Discover authentic Jamaican brands, artisans and manufacturers. Every purchase supports a local entrepreneur.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h2 className="font-display text-2xl font-bold mb-5">Featured Jamaican Merchants</h2>
        {loading ? <div className="grid place-items-center py-16"><Loader2 className="animate-spin text-emerald" size={32} /></div> : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {merchants.map((m) => (
              <Link key={m.slug} to={`/merchant/${m.slug}`} className="group bg-card rounded-2xl border border-border p-6 sn-card-hover flex gap-4">
                <img src={m.logo} alt={m.name} className="h-16 w-16 rounded-2xl object-cover" />
                <div>
                  <div className="flex items-center gap-1.5"><h3 className="font-display font-bold">{m.name}</h3>{m.verified && <BadgeCheck size={16} className="text-emerald" />}</div>
                  <div className="text-xs text-muted-foreground flex items-center gap-1 mt-0.5"><MapPin size={12} /> {m.parish} · ⭐ {m.rating}</div>
                  <p className="text-sm text-slate-600 mt-2 line-clamp-2">{m.blurb}</p>
                </div>
              </Link>
            ))}
          </div>
        )}

        <h2 className="font-display text-2xl font-bold mb-5">Jamaica Made Products</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      </div>
    </div>
  );
}
